export default {
  operation: {
    title: '打印列表',
    Printthetemplate: '打印模板 ',
    purchaseNo: '单号:',
    batchPurQty: '订单量:',
    del: '删除',
    split: '拆分',
    operate: '操作',
    edit: '编辑',
    achieve: '完成',
    hint1: '数量累加不可大于订单总量！',
    hint2: '数量和单包数量不可为空！',
    hint3: '单包数量不可大于数量！',
    docNo: '单号',
    docDate: '单据日期',
    purOfficeName: '采购中心',
    supplierNo: '供应商编号',
    supplierName: '供应商名称',
    itemNo: '物料编码',
    itemName: '品名',
    itemSpec: '规格',
    barRuleNo: '条码规则',
    businessUnitNo: '交易单位',
    businessUnitName: '交易单位名称',
    businessQty: '交易数量',
    itemRule: '管理粒度',
    qty: '数量',
    packQty: '单包数量',
    unitNo: '库存单位',
    unitName: '库存单位名称',
    printerTimes: '打印时机',
    supplierLotNo: '供应商批次号',
    lotDesc: '批次说明',
    supplierBarcode: '供应商条码',
    combinationLotNo: '批次号',
    remark: '备注',
    productDate: '生产日期',
    vldDate: '到期日期',
    label: [{ value: 98, label: '依照送货单' }, { value: 99, label: '依照采购单' }],
    hint4: '打印时机不能为空!',
    hint5: '单号不能为空',
    hint6: '请选择模板!',
    hint7: '数量/单包数量不能为0!',
    hint8: '请选择模板!',
    hint9: '请先确认编辑操作!',
    hint10: '请选择到期日期！',
    orgNo: '采购中心',
    barcode: '条码编号',
    genMoment: '条码产生时机',
    lotDate: '批次日期',
    customerNo: '客户编号',
    barType: '物料条码类型',
    supplierProductDate: '供应商生产日期',
    supplierProductLot: '供应商生产批次',
    sourceNo: '来源单号',
    sourceSeq: '来源项次',
    barcodeWeight: '标签重量/体积',
    referenceQty: '参考数量',
    referenceUnitNo: '参考单位',
    customerBarcode: '客户条码',
    snBarcodeStatus: 'SN码流转状态',
    statusCode: '状态码'
  },
  search: {
    purchaseUnitNo: '采购中心',
    itemNo: '料号',
    itemName: '品名',
    itemSpec: '规格',
    searchPlaceholder: '输入单号/料号进行查询',
    supplierNo: '供应商',
    combinationLotNo: '批号',
    barcode: '条码'
  }
}
